var mouseDownFn = 0;
$(document).ready(function(){
  $('[data-purpose="quantity-change-button"]').click(function(e){
    if ($(this).hasClass('inactive')) {
      e.preventDefault();
      return false;
    } else {
      refreshQuantityField($(this));
    }
  });

  $('[data-purpose="quantity-change-button"]').on('mousedown', function(){
    var btn = $(this);
    mouseDownFn = setInterval(function(){
      refreshQuantityField(btn);
    }, 400);
  }).on('mouseup mouseleave', function(){
    clearInterval(mouseDownFn);
  });
});

function refreshQuantityField(button) {
  if (!button.hasClass('inactive')) {
    var panel = button.parents('[data-purpose="quantity-control-panel"]');
    if (panel && panel.length == 1) {
      var field = panel.find('[data-purpose="quantity"]');
      if (field && field.length == 1) {
        var value = parseInt(field.val()) + parseInt(button.data('value'));
        if (value <= 1) {
          value = 1;
        }

        field.val(value);
        field.change();
        if (button.data('type') !== 'minus') {
          var minus = panel.find('[data-purpose="quantity-change-button"][data-type="minus"]');
          if (minus && minus.length == 1) {
            if (value > 1 && minus.hasClass('inactive')) {
              minus.removeClass('inactive');
            }
          }
        } else if (value == 1 && !button.hasClass('inactive')) {
          button.addClass('inactive');
          clearInterval(mouseDownFn);
        }
		var product_id = button.closest('[data-pid]').data('pid');
		if (product_id !== undefined) {
			 check2Qua(product_id, value);
		}
      }
    }
  }
}
